import { gql } from 'graphql-tag';

export default gql`
  query GetUserStatsAdmin {
    getUserStatsAdmin {
      totalUsers {
        value
        change
        changeText
        isPositive
      }
      avgLifetimeValue {
        value
        change
        changeText
        isPositive
      }
      avgEventsPerUser {
        value
        change
        changeText
        isPositive
      }
      avgUsersPerEvent {
        value
        change
        changeText
        isPositive
      }
      superFans {
        value
        change
        changeText
        isPositive
      }
    }
  }
`;
